//import {flip} from 'react-animations';
import { StyleSheet} from 'aphrodite';

export const scale3d = (a, b, c) => {
  return 'scale3d(' + a + ', ' + b + ', ' + c + ')';
};

export const  translate3d = (a, b, c) => {
  return 'translate3d(' + a + ', ' + b + ', ' + c + ')';
};
/*
export const  perspective = (a) => {
  return 'perspective(' + a + ')';
};

export const  rotate3d = (a, b, c, d) => {
  return 'rotate3d(' + a + ', ' + b + ', ' + c + ', ' + d + 'deg)';
};



export const compose = () => {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
};

export const perspectiveAndRotate = (0,compose)(perspective,rotate3d);
export const perspectiveTranslateRotate = (0,compose)(perspective,translate3d,rotate3d);
export const perspectiveAndScale = (0, compose)(perspective, scale3d);

export const  flippy = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -360])
  },
  '40%': {
    animationTimingFunction: 'ease-out',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -190])
  },
  '50%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -170])
  },
  '80%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndScale('400px', [0.95, 0.95, 0.95])
  },
  to: {
    animationTimingFunction: 'ease-in',
    transform: (0, perspective)('400px')
  }
};
*/
export const  bounceOut = {
    '20%': {
      transform: (0, scale3d)(0.9, 0.9, 0.9)
    },
    '50%': {
      transform: (0, scale3d)(1.1, 1.1, 1.1)
    },
    '55%': {
      transform: (0, scale3d)(1.1, 1.1, 1.1)
    },
    to: {
      opacity: 0.5,
      transform: (0, scale3d)(0.8, 0.8, 0.8)
    }
};

export const  bounceOutLogo = {
    '20%': {
      transform: (0, scale3d)(0.9, 0.9, 0.9)
    },
    '50%': {
      transform: (0, scale3d)(1.1, 1.1, 1.1)
    },
    '55%': {
      transform: (0, scale3d)(1.1, 1.1, 1.1)
    },
    to: {
      opacity: 0.8,
      transform: (0, scale3d)(0.9, 0.9, 0.9)
    }
};

export const  bounceOutCurrent = {
    '20%': {
      transform: (0, scale3d)(0.9, 0.9, 0.9)
    },
    '50%': {
      transform: (0, scale3d)(1.2, 1.2, 1.2)
    },
    '55%': {
      transform: (0, scale3d)(1.1, 1.1, 1.1)
    },
    to: {
      opacity: 1,
      transform: (0, scale3d)(1, 1, 1)
    }
};

export const fadeIn = {
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
};

export const  bounceOutSibling = {
    '20%': {
        transform: (0, scale3d)(0.95, 0.95, 0.95)
      },
      '50%': {
        transform: (0, scale3d)(1.05, 1.05, 1.05)
      },
      '55%': {
        transform: (0, scale3d)(1.05, 1.05, 1.05)
      },
      to: {
        opacity: 1,
        transform: (0, scale3d)(0.98, 0.98, 0.98)
      }
};

export const  bounceOutCousin = {
    '20%': {
        transform: (0, scale3d)(1, 1, 1)
      },
      '50%': {
        transform: (0, scale3d)(1.03, 1.03, 1.03)
      },
      '55%': {
        transform: (0, scale3d)(1.05, 1.05, 1.05)
      },
      to: {
        opacity: 1,
        transform: (0, scale3d)(1, 1, 1)
      }
};

export const  fadeInRight = {
  from: {
    opacity: 0,
    transform: (0, translate3d)('100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};

export const fadeInLeft = {
  from: {
    opacity: 0,
    transform: (0, translate3d)('-100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};

export const styles = StyleSheet.create({
    logoPulse: {
        animationName: bounceOutLogo,
        animationDuration: '1s'
    },
    bounceTitle: {
        animationName: bounceOut,
        animationDuration: '800ms'
    },
    currentCompetencePulse: {
        animationName: bounceOutCurrent,
        animationDuration: '600ms'
    },
    siblingCompetencePulse: {
        animationName: bounceOutSibling,
        animationDuration: '800ms'
    },
    cousinsCompetencePulse: {
        animationName: bounceOutCousin,
        animationDuration: '1s'
    },
    fadeIn: {
      animationName: fadeIn,
      animationDuration: '2s'
    },
    fadeInLeft: {
      animationName: fadeInLeft,
      animationDuration: '2s'
    },
    fadeInRight: {
      animationName: fadeInRight,
      animationDuration: '2s'
    },
   
});



// WEBPACK FOOTER //
// ./src/components/common/animation.js